(() => {
  const contextElement = document.getElementById('ink-market-context');
  const main = document.getElementById('MainContent');
  if (!main || !contextElement) return;
  let context;
  try { context = JSON.parse(contextElement.textContent); } catch { return; }
  if ((!context.quantity && context.scope !== 'deals') || !['US', 'GB', 'CA'].includes(context.country)) return;
  if (context.locale && context.locale.split('-')[0] !== 'en') return;

  const excluded = 'script, style, textarea, input, select, option, code, pre, h1, .ink-artwork-upload, [data-ink-roll-options], .jdgm-widget, [id^="judgeme"], [class*="jdgm-"], [class*="jm-"]';
  const number = '(?:\\d+(?:\\.\\d+)?)';
  const range = number + '\\s*[–-]\\s*' + number;
  const measurement = new RegExp(
    '(?:' + range + '|' + number + ')\\s*(?:mm|cm)\\s*\\((?:' + range + '|' + number + ')\\s*(?:in|inches?)\\)' +
    '|(?:' + range + '|' + number + ')(?:-|\\s+)(?:in|inches?)\\s*\\((?:' + range + '|' + number + ')\\s*(?:mm|cm)\\)' +
    '|(' + number + ')\\s*[–-]\\s*(' + number + ')(?:-|\\s+)(?:inch|inches|in)\\b' +
    '|(' + number + ')(?:-|\\s+)(?:inch|inches)\\b', 'g'
  );
  const mm = value => String(Number((Number(value) * 25.4).toFixed(1)));
  const formatSize = (first, last) => {
    const imperial = last ? first + '–' + last : first;
    const metric = last ? mm(first) + '–' + mm(last) : mm(first);
    return context.country === 'US'
      ? imperial + ' in (' + metric + ' mm)'
      : metric + ' mm (' + imperial + ' in)';
  };
  const ukWords = new Map([
    ['color', 'colour'], ['colors', 'colours'], ['colorful', 'colourful'], ['colored', 'coloured'],
    ['organized', 'organised'], ['organize', 'organise'], ['organizing', 'organising'],
    ['fulfillment', 'fulfilment'], ['labeling', 'labelling'], ['labeled', 'labelled'],
    ['centered', 'centred'], ['customize', 'customise'], ['customized', 'customised'],
    ['personalized', 'personalised'], ['shipping', 'delivery']
  ]);
  const preserveCase = (source, target) => source === source.toUpperCase()
    ? target.toUpperCase()
    : source[0] === source[0].toUpperCase() ? target[0].toUpperCase() + target.slice(1) : target;
  const localize = value => {
    if (/https?:\/\//.test(value)) return value;
    let output = value.replace(measurement, (whole, first, last, single) => first
      ? formatSize(first, last)
      : single ? formatSize(single) : whole);
    if (context.scope === 'deals') {
      output = output.replace(/Within\s+24\s+Hours/gi, context.proofStage)
        .replace(/1\s*[-–]\s*2\s+Business\s+Days/gi, context.productionStage)
        .replace(/6\s*[-–]\s*10\s+Business\s+Days\s*\(US\)/gi, context.deliveryStage);
    }
    if (context.country === 'GB') {
      if (context.shippingBenefit) output = output.replace(/\bFree (?:Shipping|Delivery) & Delivery Terms\b/gi, context.shippingBenefit);
      output = output.replace(/\b(color|colors|colorful|colored|organized|organize|organizing|fulfillment|labeling|labeled|centered|customize|customized|personalized|shipping)\b/gi,
        word => preserveCase(word, ukWords.get(word.toLowerCase())));
    } else if (context.country === 'CA') {
      output = output.replace(/\b(color|colors|colorful|colored)\b/gi,
        word => preserveCase(word, ukWords.get(word.toLowerCase())));
    }
    return output;
  };
  const eligible = node => !node.parentElement?.closest(excluded);
  const update = () => {
    const walker = document.createTreeWalker(main, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (!eligible(node)) continue;
      const output = localize(node.nodeValue);
      if (output !== node.nodeValue) node.nodeValue = output;
    }
  };
  let pending = false;
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; update(); });
  };
  update();
  main.dataset.inkMarketLocalized = context.country;
  const observer = new MutationObserver(mutations => {
    if (mutations.some(mutation => eligible(mutation.target) &&
      (mutation.type === 'characterData' || mutation.addedNodes.length))) schedule();
  });
  observer.observe(main, { childList: true, characterData: true, subtree: true });
  document.addEventListener('shopify:section:load', schedule);
})();
